module.exports = __webpack_public_path__ + "static/media/single_beep.d932c606.mp3";